<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 전국 대학교에
                                공무원 및 취업 정보지 무료 배포 진행</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                        <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_04.png"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌은 공무원 시험 또는 취업을 준비하고 있는 대학생들을 위해 전국 4년제 대학교를 대상으로 공무원, 취업을 주제로 한 정보지를 무료로 배포하고
                                있다.
                                <br><br>
                                공무원톡톡, 경찰톡톡, 소방톡톡, 취업톡톡까지 4종의 톡톡 시리즈는 각종 시험 관련 최신 뉴스와 수험 정보, 에듀윌 합격 노하우와 다양한 학습 서비스 등을
                                소개하는 정보지다.
                                <br><br>
                                에듀윌은 서울시립대, 한국외대, 홍익대 등 전국 대학교에 공무원, 취업 관련 정보지 4종과 함께 거치대를 배치하며 각 대학 담당자 및 학생들의 만족도를
                                이끌어내고 있다. 한 학교 관계자는 "학생들이 많은 관심을 가지고 있는 공무원 시험 및 취업 정보를 전달한다는 점에서 유익한 것 같고, 깔끔한 거치대도
                                만족스럽다"고 의견을 전하기도 했다.
                                <br><br>
                                에듀윌 관계자는 "현재 재고가 부족할 정도로 각 대학 관계자들의 긍정적인 반응을 얻고 있는 상황이다. 배포 대학 수를 점차 확대하며 공무원 시험 및 취업
                                준비에 대한 다양한 정보를 제공할 예정"이라고 설명했다.
                                한편 에듀윌은 세 번의 대통령상 수상을 비롯, 정부기관상 13관왕을 기록한 종합교육기업이다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news3" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 신한은행과 퇴직연금고객 교육솔루션 MOU 체결</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <!-- <li class="next">
                                    <a href="/pr/newsInfo?bIdx=315284&amp;page=1&amp;searchTarget=all"
                                        data-value="315284">
                                        <strong>다음</strong>
                                        <span>에듀윌 ESG위원회, 계영복지재단 ‘성북50플러스센터’에서 137차 쌀 나눔 기증식 가져</span>
                                    </a>
                                </li> -->
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
